// @ts-nocheck
import React from 'react';
import { lory, LoryStatic } from 'lory.js';

import Pagination from 'crehana-ui/Pagination';

import SimpleErrorBoundary from 'Jsx/Shared/ErrorBoundaries/Simple';
import { SliderProps } from './types';
import SliderStructure from './SliderStructure';

const Slider: React.FC<SliderProps & {
  showPagination?: boolean;
  dark?: boolean;
}> = ({
  children,
  itemWidth = 248,
  itemHeight = 398,
  itemGap = 16,
  paddingEdges = true,
  dark,
  showPagination,
}) => {
  const ref = React.useRef<HTMLDivElement>(null);
  const loryRef = React.useRef<LoryStatic>();
  const [currentPage, setCurrentPage] = React.useState(1);
  const ChildrenArray = React.Children.toArray(children);

  React.useEffect(() => {
    const handlePagination = e => {
      setCurrentPage(e.detail.currentSlide + 1);
    };

    if (ref && ref.current && ChildrenArray.length > 0) {
      loryRef.current = lory(ref.current, {
        rewind: false,
        infinite: false,
      });

      ref.current.addEventListener('after.lory.slide', handlePagination);
    }

    return () => {
      if (loryRef.current) {
        loryRef.current.setup();
        loryRef.current.slideTo(0);
      }
      if (ref.current) {
        ref.current.removeEventListener('after.lory.slide', handlePagination);
      }
    };
  }, [children]);

  const onPageChange = (page: number) => {
    if (loryRef.current) {
      loryRef.current.slideTo(page - 1);
    }
    setCurrentPage(page);
  };

  if (ChildrenArray.length === 0) {
    return null;
  }

  return (
    <>
      <SliderStructure
        ref={ref}
        childrens={ChildrenArray}
        itemWidth={itemWidth}
        itemHeight={itemHeight}
        itemGap={itemGap}
        paddingEdges={paddingEdges}
      />
      {showPagination ? (
        <div className="flex justify-center">
          <Pagination
            type="default-s"
            dark={dark}
            currentPage={currentPage}
            onPageChange={onPageChange}
            totalPages={ChildrenArray.length}
            className="mt-24"
          />
        </div>
      ) : null}
    </>
  );
};

export default (props: SliderProps) => (
  <SimpleErrorBoundary>
    <Slider {...props} />
  </SimpleErrorBoundary>
);
